import { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogContent, DialogTitle, Input, TextareaAutosize } from "@material-ui/core";
import { READER_THEMES } from "utils/themes";
import { useTranslation } from "react-i18next";
import formatDate from "date-fns/format";
import Icons from "components/icons";
import useStyles from "./bookmark-dialog.styles";
import { connect } from "react-redux";


const BookmarkDialog = memo((props) => {
    const { isOpen, bookmark, onClose, onSave, activeTheme } = props;
    const classes = useStyles({ activeTheme });
    const [title, setTitle] = useState('');
    const [note, setNote] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        setTitle(bookmark?.title || t('generic_bookmark'));
    }, [bookmark, setTitle]);

    useEffect(() => {
        setNote(bookmark?.note);
    }, [bookmark, setNote]);

    return (
        <Dialog open={isOpen} onClose={onClose}>
            <div className={classes.bookmarkDialog}>
                <DialogTitle className={classes.title}>{t("ebook_bookmarks_dialog_title")}</DialogTitle>
                <DialogContent>
                    <Input
                        className={classes.input}
                        disableUnderline
                        variant="outlined"
                        fullWidth
                        value={title}
                        placeholder={t("ebook_bookmarks_button_addname")}
                        onChange={e => setTitle(e.currentTarget.value)}
                    />
                    <TextareaAutosize
                        className={classes.textarea}
                        variant="outlined"
                        fullWidth
                        minRows={5}
                        placeholder={t("ebook_bookmarks_button_addnote")}
                        value={note}
                        onChange={e => setNote(e.currentTarget.value)}
                    />
                    <div className={classes.footer}>
                        <div className={classes.footerInfo}>
                            <Icons.ReaderBookmark className={classes.footerIcon}/>
                            {bookmark?.date && formatDate(new Date(bookmark.date), 'd MMMM yyyy')}{" • "}
                            {bookmark?.page && t('generic_format_page', { arg: bookmark.page })}
                        </div>
                        <div>
                            <Button
                                className={classes.cancelButton}
                                variant="outlined"
                                onClick={onClose}
                            >
                                {t('generic_button_dismissmenu')}
                            </Button>
                            <Button
                                className={classes.saveButton}
                                variant="outlined"
                                onClick={onSave(bookmark, title, note)}
                            >
                                {t('generic_button_save')}
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </div>
        </Dialog>
    )
});

BookmarkDialog.propTypes = {
    activeTheme: PropTypes.oneOf(Object.keys(READER_THEMES)).isRequired,
    isOpen: PropTypes.bool.isRequired,
    bookmark: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        date: PropTypes.string,
        page: PropTypes.number,
        note: PropTypes.string,
        selector: PropTypes.object,
    }),
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

const mapStateToProps = ({ player }) => ({
  activeTheme: player.ebookData.activeTheme,
});

export default  connect(mapStateToProps)(BookmarkDialog);
